<!-- <div class="progress-bar" *ngIf="showProgressBar">
    <mat-progress-bar [mode]="mode" [value]="value"></mat-progress-bar>
</div> -->
@if(showProgressBar$$()) {
    <mat-progress-bar [mode]="mode$ | async" [value]="value$ | async" />
}
